import {checkSticky} from "./checkSticky";

export function stickyBanner() {
    var mn = $('.bannerAction');
    var mns = "sticky";
    var hdr = $('#header').outerHeight();

 /*   checkSticky(mn, mns, hdr);

    $(window).scroll(function () {
        checkSticky(mn, mns, hdr);
    });
    $(window).resize(function () {
        var hdr = $('#header').outerHeight();
        checkSticky(mn, mns, hdr);
    });*/
}